import { render, staticRenderFns } from "./PaymentMethodFeedbackForm.vue?vue&type=template&id=76fd882f&scoped=true&"
import script from "./PaymentMethodFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodFeedbackForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodFeedbackForm.vue?vue&type=style&index=0&id=76fd882f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd882f",
  null
  
)

export default component.exports